<template>
  <div class="contenedor-nomenclatura-variantes">
    <div class="contenedor-titulo">
      <h3 class="titulo-nomenclatura-variantes">Nomenclatura de variantes OMS | Linaje Pangolín</h3>
      <hr />
    </div>
    <div class="contenedor-enlaces">
      <div class="enlace" :class="{ 'enlace-version-estatal': estado_seleccionado !== '00' }">
        <a href="https://www.who.int/en/activities/tracking-SARS-CoV-2-variants/">
          <img
            border="0"
            alt="Organización Mundial de la Salud"
            src="@/assets/img/nomenclatura-variantes/OMS.svg"
            width="100"
            height="100"
            class="a11y-simplificada-none"
          />
          <span>Organización Mundial de la Salud</span>
        </a>
      </div>
      <div class="enlace" :class="{ 'enlace-version-estatal': estado_seleccionado !== '00' }">
        <a href="https://cov-lineages.org/lineage_list.html">
          <img
            border="0"
            alt="Linajes Pango"
            src="@/assets/img/nomenclatura-variantes/Linajespango.svg"
            width="100"
            height="100"
            class="a11y-simplificada-none"
          />
          <span>Linajes Pango</span>
        </a>
      </div>
      <div class="enlace" :class="{ 'enlace-version-estatal': estado_seleccionado !== '00' }">
        <a href="https://www.pango.network/">
          <img
            border="0"
            alt="Red Pango"
            src="@/assets/img/nomenclatura-variantes/pango-network-logo.png"
            width="100"
            height="100"
            class="a11y-simplificada-none"
          />
          <span>Red Pango</span>
        </a>
      </div>
    </div>

    <div class="notas">
      <hr />
      <p class="texto-notas">
        <span class="titulo-notas">Nota: </span>Para ver todas las nomenclaturas de la OMS y los
        Linajes Pango puedes consultar las siguientes fuentes.
      </p>
      <p class="texto-notas">
        Con base en la frecuencia de aparición de las variantes en las muestras secuenciadas,
        actualmente la OMS divide a todas las variantes de preocupación (VOC) y a las variantes de
        interés (VOI) en dos grupos: 1) circulación actual (variantes de mayor frecuencia) y 2)
        circulación previa (variantes de menor frecuencia). En el primer grupo se encuentran las
        variantes VOC Delta y Omicron y en el segundo grupo las variantes VOC Alpha, Beta y Gamma,
        así como todas las variantes VOI (Epsilon, Zeta, Eta, Theta, Iota, Kappa, Lambda y Mu). En
        este tablero, se consideran todas las variantes VOC y las variantes VOI Lambda y Mu, a pesar
        de que sean de circulación previa, con el fin de mostrar la evolución de la pandemia en
        México.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    estado_seleccionado() {
      return this.$store.getters.estadoSeleccionado;
    },
  },
};
</script>

<style scoped lang="scss">
.contenedor-nomenclatura-variantes {
  hr {
    margin: 0 0 0;
  }
}
.titulo-nomenclatura-variantes {
  font-size: 16px;
  padding: 10px;
  margin: 0 15px;
}
/* Acomodo de los elementos de los links */
.contenedor-enlaces {
  // padding: 0 45px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (min-width: map-get($media-queries-limit, "mobile")) {
    flex-direction: row;
    align-items: start;
  }

  .enlace {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
    margin: 8px 16px;
    overflow-wrap: break-word;

    img {
      max-width: 100%;
      height: auto;
      margin: 0 8px;
      // object-fit: contain;
    }

    &-version-estatal {
      margin: 20px 0;
      width: 33%;
      a {
        font-size: 12px;
        display: block;
        text-align: center;
        padding: 10px;
        img {
          display: inline-block;
        }
      }
    }
  }
}
/* estilo de links sobre imagen */
.contenedor-enlaces {
  a {
    align-items: center;
    text-decoration: underline;
    &:hover {
      background: map-get($color-link, "fondo");
      color: map-get($color-link, "texto");
      // display: inline-flex;
      span {
        background: map-get($color-link, "hover-fondo");
        color: map-get($color-link, "hover-texto");
        border-radius: 3px;
      }
    }
  }
}
.notas {
  margin: 0 15px;
  hr {
    border-top: 1px solid #ddd;
  }
  .texto-notas {
    margin: 20px 15px;
    .titulo-notas {
      font-weight: 600;
    }
  }
}
</style>
